import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const loc = useLocation();
  return (
    <div className="screen not-found">
      <div className="not-found-inner">
        <div className="not-found-emoji">⛳</div>
        <div className="u-label">Out of bounds</div>
        <h1>Page not found</h1>
        <p>
          We couldn't find anything at{' '}
          <code className="not-found-path">{loc.pathname}</code>. Either the
          link is mistyped or the round has been swept up.
        </p>
        <div className="stack-sm" style={{ marginTop: '1.5rem', width: '100%' }}>
          <Link to="/" className="btn btn-primary btn-block btn-lg">
            🏠 Back to Home
          </Link>
          <Link to="/join" className="btn btn-ghost btn-block">
            Join a round with a code
          </Link>
        </div>
      </div>
    </div>
  );
}
